import { useEffect } from "react";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { supabase } from "@/lib/supabase";
import { invalidateFor } from "@/lib/cache-registry";

/**
 * VIB-3023: melder innlogget ansatt inn i husrommene (kanaler for hele huset)
 * den ikke er medlem av ennå, f.eks. nyansatte etter at «Hele Sølvrev» ble
 * seedet. RPC-en `ensure_house_memberships` bruker den ekte sesjonen
 * (`current_user_id()`), så `userId` er bare med for cache-invalideringen.
 *
 * Kjøres én gang når Chat-siden åpnes.
 */
export function useEnsureHouseMemberships(userId: string | null | undefined, enabled: boolean) {
  const qc = useQueryClient();
  const mutation = useMutation({
    mutationFn: async () => {
      const { data, error } = await supabase.rpc("ensure_house_memberships");
      if (error) throw error;
      return (data ?? 0) as number;
    },
    onSuccess: async (added) => {
      if (added > 0) await invalidateFor(qc, "chat_members", { userId });
    },
    // Ingen toast: uten innmelding mangler bare husrommet i listen, og neste
    // åpning prøver igjen.
  });

  const { mutate } = mutation;
  useEffect(() => {
    if (enabled && userId) mutate();
  }, [enabled, userId, mutate]);

  return mutation;
}
